module.exports = __webpack_public_path__ + "img/Icon - Filter.f934a4a2.svg";